import React from 'react'

import TabbedCodeBlocks from '~components/TabbedCodeBlocks'

/**
 * Shows a list of code samples
 */
const CodeSamples = ({ 
  microcopy, 
  endpoint 
}) => {
  return (
    <>
      { endpoint.samples?.[0] && (
        <section>
          <header id='request-example'>
            <h2>
              <a href='#request-example' data-display-anchor>
                { microcopy.text('reference.titles.request_example') }
              </a>
            </h2>
          </header>

          <TabbedCodeBlocks samples={endpoint.samples} />
        </section>
      )}
    </>
  )
}

export default CodeSamples